import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    discountsIncompatibilities: `${APP_CONFIG.care_cluster}/ms-discounts/incompatibilities`,
  },
}
